import { StepForward } from "lucide-react";
function NextButton({ handleNextButton, finish }) {
  return (
    <div>
      <button
        onClick={handleNextButton}
        className=" bg-yellow-500  hover:bg-yellow-600 flex justify-center items-center 
          rounded-full text-3xl text-white w-14 h-8"
      >
        <StepForward />
      </button>
    </div>
  );
}

export default NextButton;
